export default "__VITE_ASSET__28cd2ba9__"